import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function mustMatch ( matchTo: string ): ValidatorFn
{
    return (control: AbstractControl): ValidationErrors | null =>
    {
        return !!control.parent &&
        !!control.parent.value &&
        control.value === control.parent.controls[matchTo].value
            ? null
            : { mustMatch: false };
    };
}